export default "__VITE_ASSET__74709e5c__"